import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpRightIcon, TrendingDownIcon } from 'lucide-react';
import { ArrowButton } from '../ui/ArrowButton';
import { Reveal } from '../ui/Reveal';
import { SectionLabel } from '../ui/SectionLabel';
import { SplitText } from '../ui/SplitText';
import { services } from '../../data/services';
import { EASE_OUT } from '../../utils/motion';
export function ServicesSection() {
  const [active, setActive] = useState(0);
  const current = services[active];
  return <section className="bg-ink py-24 text-white lg:py-36" data-id="element-235" data-mp="bqruw2b2ri3c">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8" data-id="element-236" data-mp="bq9paf2ivrir">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-237" data-mp="gol28yo46i57">
          <div className="lg:col-span-8" data-id="element-238" data-mp="2wgqthl68ceta">
            <Reveal data-id="element-239" data-mp="2wfz6uzum1rf5">
              <SectionLabel tone="dark" data-id="element-240" data-mp="2wffo5gx4yz02">Services</SectionLabel>
            </Reveal>
            <h2 className="mt-6 max-w-3xl text-[clamp(2rem,4.2vw,3.5rem)] font-medium leading-[1.08] tracking-[-0.03em]" data-id="element-241" data-mp="31gmynnqnycaf">
              <SplitText text="Une expertise pour chaque maillon de votre chaîne de valeur." data-id="element-242" data-mp="47wc2a6ffoty" />
            </h2>
          </div>
          <Reveal delay={0.15} className="lg:col-span-4" data-id="element-243" data-mp="d68b90lczuy0">
            <p className="leading-relaxed text-white/65" data-id="element-244" data-mp="d7rsateuaa0u">
              De la négociation fournisseur à la gestion des stocks, j’interviens sur l’ensemble du cycle achats et
              approvisionnement.
            </p>
            <ArrowButton to="/services" variant="light" className="mt-6" data-id="element-245" data-mp="n2bde6g7ntky">
              Tous les services
            </ArrowButton>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-246" data-mp="vvogg17zobkr">
          <div className="hidden lg:col-span-5 lg:block" data-id="element-247" data-mp="rv4g6os4crue">
            <div className="sticky top-28 aspect-[4/5] overflow-hidden rounded-[28px] bg-ink-800" data-id="element-248" data-mp="rxqmym76r3bk">
              <AnimatePresence initial={false} data-id="element-249" data-mp="15st11wm6ryzg">
                <motion.img key={current.slug} src={current.image} alt="" initial={{
                opacity: 0,
                scale: 1.05
              }} animate={{
                opacity: 1,
                scale: 1
              }} exit={{
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: EASE_OUT
              }} className="absolute inset-0 h-full w-full object-cover" data-id="element-250" data-mp="10x3zjnqlw80i" />
              </AnimatePresence>
              <div className="absolute inset-x-5 bottom-5" data-id="element-251" data-mp="h94jahnec2m4">
                <AnimatePresence mode="wait" initial={false} data-id="element-252" data-mp="h8uuuyi023ij">
                  <motion.div key={current.slug} initial={{
                  opacity: 0,
                  y: 10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -6
                }} transition={{
                  duration: 0.2,
                  ease: EASE_OUT
                }} className="flex items-center gap-3 rounded-2xl bg-white p-4 text-ink" data-id="element-253" data-mp="m7fuowtcal6g">
                    <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-ink text-brass" data-id="element-254" data-mp="2wzh3hnqzld1o">
                      <TrendingDownIcon className="h-5 w-5" aria-hidden="true" data-id="element-255" data-mp="2phswu7ey83lk" />
                    </span>
                    <div data-id="element-256" data-mp="2kp9b2n63y25o">
                      <p className="text-xs text-muted" data-id="element-257" data-mp="2kny64k0xeocz">Résultat type</p>
                      <p className="font-medium" data-id="element-258" data-mp="2frpxzql5bvfb">{current.outcome}</p>
                    </div>
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>
          </div>

          <ul className="border-t border-white/10 lg:col-span-7" data-id="element-259" data-mp="38f3op6y93uqz">
            {services.map((service, i) => {
            const isActive = i === active;
            return <li key={service.slug} className="border-b border-white/10" data-id="element-260" data-mp="2yg4lw5062tbw" data-mpi={i}>
                  <button type="button" onClick={() => setActive(i)} onMouseEnter={() => setActive(i)} aria-expanded={isActive} aria-controls={`service-panel-${service.slug}`} className="group flex w-full items-center justify-between gap-6 py-7 text-left focus-visible:outline-none" data-id="element-261" data-mp="2ugm1rbg66ma4">
                    <span className={`text-[clamp(1.4rem,2.4vw,2rem)] font-medium tracking-[-0.02em] transition-colors duration-200 ${isActive ? 'text-white' : 'text-white/40 group-hover:text-white/70 group-focus-visible:text-white'}`} data-id="element-262" data-mp="3bovehsdhymcu">
                      {service.title}
                    </span>
                    <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-full transition-[background-color,color,transform] duration-200 ease-out-strong ${isActive ? 'rotate-45 bg-brass text-ink' : 'bg-white/[0.06] text-white/70'}`} aria-hidden="true" data-id="element-263" data-mp="3ulmunsxqslco">
                      <ArrowUpRightIcon className="h-5 w-5 -rotate-45" data-id="element-264" data-mp="299v55ulq5loe" />
                    </span>
                  </button>
                  <AnimatePresence initial={false} data-id="element-265" data-mp="21oiwsru38jih">
                    {isActive && <motion.div id={`service-panel-${service.slug}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25,
                  ease: EASE_OUT
                }} className="overflow-hidden" data-id="element-266" data-mp="1wq7mkfzvs6zq">
                        <div className="pb-8 pr-4 sm:pr-16" data-id="element-267" data-mp="1e2cd38baxfcf">
                          <p className="max-w-xl leading-relaxed text-white/70" data-id="element-268" data-mp="1sqh0uqp7oh22">{service.description}</p>
                          <ul className="mt-5 flex flex-wrap gap-2" data-id="element-269" data-mp="1nxnujye3h0nv">
                            {service.points.map(p => <li key={p} className="rounded-md bg-white/[0.07] px-3 py-1.5 text-sm text-white/80" data-id="element-270" data-mp="107a4gdf2lbvx">
                                {p}
                              </li>)}
                          </ul>
                          <Link to={`/services#${service.slug}`} className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-brass hover:underline" data-id="element-271" data-mp="1oz8wreyy2e4m">
                            En savoir plus
                            <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-272" data-mp="11zkw1i5lm8y7" />
                          </Link>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}